// components/common/ViewModal.tsx

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

interface ViewModalProps {
  open: boolean;
  onClose: () => void;
  initialData: { [key: string]: any };
  excludeFields?: string[];
  readOnlyFields?: string[];
  title: string;
}

const ViewModal: React.FC<ViewModalProps> = ({
  open,
  onClose,
  initialData,
  excludeFields,
  readOnlyFields,
  title
}) => {

  const capitalizeLabel = (label: string) => {
    const words = label.replace(/([A-Z])/g, ' $1'); // Insert space before capital letters
    return words.charAt(0).toUpperCase() + words.slice(1); // Capitalize first letter
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" className='roleModal'>
        <CancelIcon onClick={onClose} className='closeModal' />
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
         <Box className="modalFormWrap">
            <Box component="form" className="modalForm">
{Object.entries(initialData).map(([key, value]) => {
  if (excludeFields && excludeFields.includes(key)) return null;
  const isReadOnly = readOnlyFields?.includes(key);
  return (
    <div className="form-control inputFieldWrap" key={key}>
      <label className="editModalLabel">{capitalizeLabel(key)}</label>
      <input
        type="text"
        className="inputField"
        value={value}
        readOnly={true}
        style={isReadOnly ? { backgroundColor: '#f7fcff', cursor: 'not-allowed' } : {}}
      />
    </div>
  );
})}
            </Box>
         </Box>
        
      </DialogContent>
    </Dialog>
  );
}; 

export default ViewModal;
